import { PropsWithChildren } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export interface SenecCardHeaderProps {
    title?: string;
    small?: boolean;
    disabled?: boolean;
}

export const SenecCardHeader = ({ title, small, disabled, children }: PropsWithChildren<SenecCardHeaderProps>) => {
    if (!title && !children) return <></>;

    const theme: SenecFPPTheme = useTheme();
    const titleColor = disabled ? theme.palette.neutralGray50.main : theme.palette.text.primary;

    return (
        <Stack
            direction={"row"}
            spacing={2}
            justifyContent={"space-between"}
            data-testid={"senec-card-header"}
            useFlexGap
            flexWrap="wrap"
        >
            {title && (
                <Typography
                    variant={small ? "h6" : "h4"}
                    sx={{ alignSelf: "center", wordBreak: "break-word", color: titleColor }}
                >
                    {title}
                </Typography>
            )}
            {children && (
                <Stack direction={"row"} spacing={"0.75rem"}>
                    {children}
                </Stack>
            )}
        </Stack>
    );
};
